import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	Text,
} from "@chakra-ui/react";
import React from "react";
import { FaLinkedin } from "react-icons/fa";

const FundInFocusAugust: React.FC = () => (
	<>
		{/* members */}
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					Fund In Focus: From BigBasket to ixigo-
					<Link
						href="https://trifectacapital.in/"
						target="_blank"
						rel="noreferrer"
						mr="5px"
					>
						Trifecta Capital&#39;s
					</Link>
					Role in Scaling India&#39;s Top Startups
				</Heading>
				<Text
					fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
					fontWeight="600"
					color="white"
					lineHeight="21px"
				>
					Rahul Khanna, Co- Founder and Managing Partner,
					<Link
						href="https://trifectacapital.in/"
						target="_blank"
						rel="noreferrer"
					>
						Trifecta Capital
					</Link>
				</Text>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box as="main" w="100%" pb="40px">
				<Text variant="blogAnswer">
					Welcome to our ‘Fund in Focus’ series where we profile our member VC
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to Rahul Khanna, Co-Founder and
					Managing Partner, Trifecta Capital – who delves into the strategic
					importance of venture debt in India&#39;s burgeoning startup
					ecosystem. Founded in 2015, Trifecta identified a critical gap for
					non-dilutive financing, enabling startups to scale without excessive
					equity dilution. Rahul highlights the key advantages of venture debt,
					such as preserving ownership and providing flexible funding. With
					securing INR, 2000 Cr for fourth fund, Trifecta shares lessons from
					managing multiple funds, and further supporting high-growth companies
					through equity.
				</Text>
			</Box>

			<Img
				src="https://static.levocdn.com/WGLBUT82/Screenshot2024-08-01at114817AM-yCrF3MWWXP1R.png"
				alt="Rahul Khanna"
				boxSize="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="contain"
			/>
			<Box>
				<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
					<Heading
						textAlign={{ xs: "center", md: "left" }}
						fontWeight="800"
						color="blue.400"
					>
						Spokesperson: Rahul Khanna, Co- Founder and Managing Partner,
						<Link
							href="https://trifectacapital.in/"
							target="_blank"
							rel="noreferrer"
						>
							Trifecta Capital
						</Link>
					</Heading>
					<Flex
						columnGap={{ xs: "4px", md: "16px" }}
						justifyContent={{ xs: "center", md: "flex-start" }}
						transform={{ xs: "translateX(12px)", md: "none" }}
					>
						<Box alignSelf="start" mt="5px">
							<Link
								href="https://www.linkedin.com/in/khannarahul/"
								target="_blank"
							>
								<IconButton
									aria-label="linkedin"
									icon={
										<FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
									}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Box>
					</Flex>
				</Flex>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box>
					<Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
						1. How did Trifecta Capital identify venture debt as a strategic
						need in the Indian startup ecosystem?
					</Heading>
					<Text variant="blogAnswer" pb="20px">
						We started Trifecta Capital in 2015, a time when the Indian startup
						ecosystem was truly beginning to break out. Companies like Flipkart,
						InMobi, and Freshworks were not only catching the eyes of Indian
						investors but also attracting significant global attention. The
						first generation of Indian startups was thriving, backed by
						substantial equity funding. However, we noticed a big issue: with no
						debt financing available for startups, founders were becoming overly
						reliant on equity, leading to significant dilution of their
						ownership stakes. We also realised as these companies grow in the
						next 2-5 years, founders won’t be left with much equity to dilute
						further.
						<br />
						<br />
						Traditional banks and NBFCs were not viable options for these young
						companies. These institutions were heavily regulated and
						risk-averse, making them unwilling or unable to lend to startups,
						especially those led by first-generation founders with businesses
						that were just a few years old. There was a clear whitespace in the
						ecosystem for an alternative form of non-dilutive financing and
						having seen venture debt as a relatively large asset class in the
						US, we believed that it was a good time to build this in India. By
						offering non-dilutive capital, we could provide founders with the
						necessary funds to scale their businesses while allowing them to
						retain more control and ownership.
					</Text>
				</Box>
				{/* Question 2 */}
				<Box pt="20px">
					<Heading variant="blogQuestion" pb="20px" pt="30px">
						2. What are the key advantages venture debt offers startups compared
						to traditional equity financing?
					</Heading>
					<Box>
						<Text variant="blogAnswer" pb="16px">
							Venture debt offers several key advantages over traditional equity
							financing. First and foremost, it provides non-dilutive capital,
							meaning that founders can secure the funds they need without
							giving up additional equity. This is crucial for preserving
							ownership stakes and control within the company. Additionally, the
							cost of venture debt is often lower than the cost of equity,
							especially when you consider the long-term value of retained
							equity.
							<br /> <br />
							Another significant advantage is the flexibility in how the funds
							can be used. Venture debt can be deployed for specific purposes
							such as working capital, capital expenditure, and acquisitions.
							This allows startups to use their equity capital for strategic
							investments and growth initiatives rather than spending it on
							operational needs. Moreover, by supplementing equity with debt,
							startups can extend their financial runway. This helps them delay
							the need for subsequent equity rounds and potentially achieve
							higher valuations.
							<br />
							<br />
							Venture debt is particularly useful at later stages, like Series B
							and beyond when companies have already established their
							product-market fit and are generating revenue. At this point,
							founders often want to minimise incremental dilution for existing
							shareholders while still securing the capital necessary for
							scaling operations. By opting for venture debt, they can achieve
							this balance effectively.
						</Text>
					</Box>
				</Box>

				{/* Question 3 */}

				<Box py="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. Can you elaborate on specific examples of how Trifecta
						Capital&#39;s debt solutions have helped portfolio companies achieve
						milestones?
					</Heading>
					<Box pt="16px">
						<Text variant="blogAnswer" pb="8px">
							One of our recent success stories is ixigo. Our relationship with
							the company began in 2021 through our debt fund, and seeing its
							promising potential, we later doubled down on the company via our
							growth equity fund. ixigo went public on June 18th this year, and
							the IPO was a resounding success, opening at a 48% premium and
							reaching a 78% premium before hitting the upper circuit on the
							opening day.
						</Text>
						<Text variant="blogAnswer" mt="12px">
							ixigo is the poster child of long-term sustainable growth. As the
							country and the company were emerging from the first wave of the
							pandemic, travel traffic had started to recover but remained below
							pre-COVID levels. The founders, anticipating a significant
							post-pandemic travel boom due to lockdown fatigue, were looking to
							expand. They saw an opportunity to broaden their market by
							acquiring bus booking services, with additional capital. However,
							the equity valuations available at the time were not meeting their
							expectations, as VC-backed companies focused on sustainable growth
							were not in fashion in 2021, everyone wanted companies to
							blitzscale. <br />
							<br />
							After the pandemic, ixigo demonstrated robust growth, achieving a
							~92% revenue CAGR between FY21-23 and 35% growth in the first nine
							months of FY24. The company has been EBITDA profitable for the
							last three financial years since FY21, reporting a 7.8% EBITDA
							margin in the first nine months of FY24. This consistent EBITDA
							profitability and growth including in the bus segment were an
							integral part of the success of ixigo’s IPO.
						</Text>
					</Box>
				</Box>

				{/* Question 4 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							4. Trifecta Capital boasts an impressive portfolio with unicorns
							like BigBasket and Cars24. Can you share your investment thesis
							when selecting startups for venture debt?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								We typically target companies that have moved past the initial
								concept stage are revenue-generating and have established
								product-market fit. These are usually Series A or B-stage
								companies and beyond, which are looking to scale rapidly. We
								also ensure that there is a strong use case for venture debt as
								well as security in the form of current assets, brand, or IP to
								secure ourselves. Our due diligence process involves a thorough
								assessment of the company&#39;s management, business model, cash
								flows and overall financial health. We also assess the quality
								of the company’s cap table as well as the likelihood of raising
								the next round of equity financing. <br />
								<br />
								Equally importantly, at a portfolio level, we believe that a
								fund must be highly diversified and so we ensure that we limit
								our exposure to any sector based on predefined limits.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Question 5 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							5. Beyond established sectors like e-commerce and logistics, are
							there any emerging areas where Trifecta Capital sees potential for
							venture debt deployment?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								Absolutely, we see immense potential in several emerging areas.
								The fintech sector is one such area where companies often use
								venture debt for onward lending and managing their balance sheet
								needs. In the SaaS and enterprise tech sectors, the long
								gestation periods for contracts make venture debt an ideal
								solution for bridging cash flow gaps until revenues start coming
								in. We&#39;re also excited about the healthcare, manufacturing,
								and industrial sectors. These industries often require
								substantial upfront investment in R&amp;D and infrastructure,
								which can be efficiently financed through venture debt. <br />
								<br />
								Another promising area is EV, clean energy, and sustainability.
								With the global shift towards EV, and clean energy, companies in
								this sector need significant capital for technology development
								and infrastructure. Venture debt provides a viable funding
								solution that aligns well with their long-term goals.
								Additionally, as more companies prepare for IPOs, we&#39;re
								seeing unique use cases for venture debt, such as financing
								share buybacks and funding expenses related to the reverse
								flipping of entities.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Question 6 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							6. Trifecta Capital successfully closed its third fund at ₹1,777
							crore in 2023 and deployed a sizeable portion. Can you discuss the
							learnings and experiences from managing multiple funds?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								Managing multiple funds has been an incredible learning
								experience. One of the biggest lessons has been the importance
								of portfolio diversification. We&#39;ve learned to balance
								high-growth companies with more stable, cash-generating
								businesses to mitigate risks and maximise returns. Over time,
								our due diligence processes have evolved to take into account
								lessons learned through financing this ecosystem through cycles.{" "}
								<br />
								<br />
								Building strong relationships with our portfolio companies has
								also been crucial. We provide not just capital, but also
								strategic guidance, leveraging our expertise to help founders
								navigate growth challenges. Another key learning has been the
								need to continually adapt our underwriting and risk management
								practices to align with market trends and external factors like
								regulation and geopolitics. The dynamic nature of the startup
								ecosystem requires us to stay flexible and proactive in our
								approach.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Question 7 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							7. With plans to launch Trifecta Leaders Fund-II, how will
							Trifecta Capital expand its offerings beyond venture debt and
							cater to the growth stage through equity?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								The Trifecta Leaders Fund strategy is a natural extension of our
								mission to support high-growth companies through their lifecycle
								as private companies. Our venture debt investments have given us
								deep insights into the performance and potential of many
								sector-leading companies. This positions us uniquely to provide
								growth-stage equity, especially for companies transitioning from
								startup to more established growth stages, typically at Series C
								or D stages where historically fewer VCs have operated.
								<br />
								<br />
								We&#39;ve built strong relationships with these companies and
								have a wealth of data on their growth trajectories and capital
								needs. This data-driven approach guides our equity investments,
								ensuring we back companies with strong fundamentals and scalable
								business models. Additionally, our experience will be very
								valuable to these companies as they navigate the complexities of
								scaling operations and eventually giving investors an exit by
								way of IPO or M&amp;A, something that our team is well-equipped
								to support. Essentially, our venture debt fund has created a
								robust pipeline for our growth equity fund, allowing us to
								seamlessly expand our offerings and continue supporting the
								ecosystem.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Question 8 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							8. As a pioneer in the Indian venture debt landscape, how does
							Trifecta Capital contribute to the overall growth and maturity of
							this asset class?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								Since our inception, Trifecta Capital has been at the forefront
								of the venture debt market in India. We&#39;ve deployed over INR
								6,000 crore through our three venture debt funds, capturing
								between 25% and 30% of this asset class. Our disciplined
								approach has kept write-offs below 1%, demonstrating the
								viability and stability of venture debt.
								<br />
								<br />
								Our impact extends beyond just funding. By providing
								non-dilutive capital, we&#39;ve helped numerous startups scale
								effectively, contributing significantly to the overall growth
								and maturity of the Indian startup ecosystem. We actively
								educate founders and investors about the benefits of venture
								debt, fostering a deeper understanding and wider acceptance of
								this financing option. Our successful fundraises and investment
								performance have encouraged other players to enter the market,
								enhancing the overall ecosystem and providing more options for
								founders.
								<br />
								<br />
								Lastly, Trifecta Capital has played a key role in expanding the
								participation of domestic institutional investors like Insurance
								Companies as well as Family Offices into the AIF ecosystem
								starting with venture debt and now more broadly across different
								asset classes.
							</Text>
						</Box>
					</Box>
				</Flex>
				{/* Question 9 */}
				<Flex py="16px">
					<Box>
						<Heading variant="blogQuestion" pt="16px">
							9. Recently Trifecta Capital launched Venture Debt Fund IV. Can
							you share any insights into the target corpus and investment
							strategy for this upcoming fund?
						</Heading>
						<Box>
							<Text variant="blogAnswer" py="16px">
								On the back of the success of its previous three venture debt
								Funds, Trifecta Capital has recently launched Venture Debt Fund
								IV with a target size of INR 2,000 crores (including a greenshoe
								of INR 500 crores) and is seeing a good response from existing
								and new investors. The firm expects continued investment from
								its onshore and offshore investors given the attractive returns
								to date and the consistent track record of prior funds.
								<br />
								<br />
								Looking ahead, our strategy will be to continue backing market
								leaders and high-potential startups. The target corpus will
								reflect our ambition to further solidify our market position and
								support a broader array of companies.
								<br />
								<br />
								Our investment strategy will emphasise backing companies that
								prioritise profitability and sustainable growth. We&#39;ll
								maintain our sector-agnostic approach, exploring opportunities
								across various industries while also venturing into emerging
								sectors. Additionally, we&#39;ll continue providing not just
								capital, but also strategic and operational support to help our
								portfolio companies achieve their milestones and scale
								successfully. Our goal is to build on our existing success and
								contribute even more significantly to the ecosystem.
							</Text>
						</Box>
					</Box>
				</Flex>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusAugust;
